/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_S62_IntroInputs */

const es_tyc_liability_s62_intro = /** @type {(inputs: Tyc_Liability_S62_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada en estos Terminos excluira ni limitara la responsabilidad de Nexata por:`)
};

const en_tyc_liability_s62_intro = /** @type {(inputs: Tyc_Liability_S62_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing in these Terms will exclude or limit Nexata liability for:`)
};

/**
* | output |
* | --- |
* | "Nothing in these Terms will exclude or limit Nexata liability for:" |
*
* @param {Tyc_Liability_S62_IntroInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_s62_intro = /** @type {((inputs?: Tyc_Liability_S62_IntroInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_S62_IntroInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_s62_intro(inputs)
	return en_tyc_liability_s62_intro(inputs)
});
export { tyc_liability_s62_intro as "tyc.liability.s62_intro" }